import signalr from 'BASE/common/signalrAdapter'
import { mutationTypes } from 'BASE/store/types'
import State from 'BASE/store/chat/chat.store.state'
import Mutations from 'BASE/store/chat/chat.store.mutations'
import Actions from 'BASE/store/chat/chat.store.actions';
import Getters from 'BASE/store/chat/chat.store.getters';
import StoreSignalrCallbackRegister from 'BASE/store/chat/chat.store.signalrCallback';

class ChatRegister {
    constructor() {
        this.isOngoing = false;
        this.isInitiated = false;
    }

    initialize(vue, initDone, isForce = true) {
        if (!isForce && this.isInitiated) {
            if (initDone) {
                initDone()
            }
            return;
        }

        //確認signalR連線當下的token是否存在, 避免還在登入畫面時因沒token去拿getInitialData會出現unauthorized user錯誤訊息
        if (!signalr.getLoginValidatedStatus()) {
            return;
        }
        //以防聊天室頁面按F5刷新時重複執行多次註冊
        if (this.isOngoing) {
            // 防止在聊天室頁面重整時，因其他地方先執行 register initialize，造成狀態還在執行，導致沒有執行到聊天室頁面的 initDone
            setTimeout(() => {
                this.initialize(vue, initDone, false)
            }, 1000)
            return;
        }
        this.isOngoing = true;

        if (vue.$store.state.chat) {
            this.destroy(vue);
        }
        vue.$store.registerModule('chat', {
            state: new State(),
            mutations: new Mutations(),
            actions: new Actions(),
            getters: new Getters(),
        });

        signalr.addWorkOnConnected(async () => {
            let result = await signalr.chatServer.getInitialData();
            let hasChatExternalLink = vue.$store.state.userinfo.hasChatExternalLink;
            let excludeIsChatDenied = vue.options ? vue.options.excludeIsChatDenied : false;
            vue.$store.commit(mutationTypes.CHAT_INIT_DATA, 
                { result: result,
                    hasChatExternalLink: hasChatExternalLink, 
                    excludeIsChatDenied: excludeIsChatDenied 
                }
            );

            if (initDone) {
                initDone()
            }
            
            this.isInitiated = true;
            this.isOngoing = false;
        });
        (new StoreSignalrCallbackRegister).registerAll(vue);
    }

    destroy(vue) {
        vue.$store.unregisterModule('chat');
    }
}

export default new ChatRegister();